import { render, staticRenderFns } from "./GridMatchTable.vue?vue&type=template&id=6f6599a7&scoped=true&"
import script from "./GridMatchTable.vue?vue&type=script&lang=js&"
export * from "./GridMatchTable.vue?vue&type=script&lang=js&"
import style0 from "./GridMatchTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GridMatchTable.vue?vue&type=style&index=1&id=6f6599a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6599a7",
  null
  
)

export default component.exports